import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, Lock } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin/warranty"); }, [user, navigate]);

  const submit = async (e) => {
    e?.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/warranty");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0F172A] px-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex flex-col items-center">
          <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-600">
            <ShieldCheck className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-display text-2xl font-extrabold tracking-tight text-white">IDEA RMA System</h1>
          <p className="text-sm text-slate-400">Internal Admin Portal</p>
        </div>
        <form onSubmit={submit} className="rounded-2xl bg-white p-8 shadow-2xl">
          <h2 className="mb-6 flex items-center gap-2 font-display text-lg font-semibold text-slate-900">
            <Lock className="h-4 w-4 text-blue-600" /> Sign in
          </h2>
          {error && <div data-testid="login-error" className="mb-4 rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
          <div className="space-y-4">
            <div>
              <Label className="mb-1.5 block text-sm font-medium">Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@idea.om" required />
            </div>
            <div>
              <Label className="mb-1.5 block text-sm font-medium">Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
          </div>
          <Button type="button" onClick={submit} disabled={loading} data-testid="login-submit" className="mt-6 w-full gap-2 bg-blue-600 hover:bg-blue-700">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Sign in
          </Button>
        </form>
      </div>
    </div>
  );
}
